import { render, staticRenderFns } from "./FoodsPie.vue?vue&type=template&id=5b21be36&scoped=true"
import script from "./FoodsPie.vue?vue&type=script&lang=js"
export * from "./FoodsPie.vue?vue&type=script&lang=js"
import style0 from "./FoodsPie.vue?vue&type=style&index=0&id=5b21be36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b21be36",
  null
  
)

export default component.exports